import React, { FC, ReactNode } from 'react'
import {
  Box,
  Text,
  useTheme,
  BoxProps,
  TextProps,
  StyleProps,
} from '@chakra-ui/react'
import { NucbaTheme } from '../../styles'

type MessageProps = {
  boxStyle?: StyleProps & BoxProps
  textStyle?: StyleProps & TextProps
  children: ReactNode
}

const Message: FC<MessageProps> = ({ boxStyle, textStyle, children }) => {
  const { colors } = useTheme<NucbaTheme>()

  return (
    <Box
      w='max-content'
      bgColor={colors.nucba['black-70']}
      borderRadius={26}
      py={3}
      paddingLeft={5}
      paddingRight={6}
      {...boxStyle}
    >
      <Text
        color='rgba(255,255,255,0.7)'
        fontSize={{ base: '14px', '2xl': 'sm' }}
        {...textStyle}
      >
        {children}
      </Text>
    </Box>
  )
}

export default Message
